import React from "react";
import { aboutCopy, services, profile } from "../data/mock";

const About = () => {
  return (
    <section
      id="about"
      className="px-6 md:px-10 max-w-[1400px] mx-auto py-20 md:py-28 border-t border-[#d8d5cc]"
    >
      <div className="grid grid-cols-12 gap-4 md:gap-8">
        <div className="col-span-12 md:col-span-3">
          <p className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64]">
            {aboutCopy.eyebrow}
          </p>
        </div>

        <div className="col-span-12 md:col-span-9">
          <h2 className="text-[30px] md:text-[50px] leading-[1.08] tracking-[-0.02em] text-[#0d0d0d] font-display max-w-4xl">
            Part producer, part art director —{" "}
            <span className="italic font-serif font-light">
              fluent in both areas.
            </span>
          </h2>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            <div className="space-y-5">
              {aboutCopy.body.map((b, i) => (
                <p key={i} className="text-[15px] md:text-base leading-[1.75] text-[#3a3a36]">
                  {b}
                </p>
              ))}

              <div className="pt-4 border-t border-[#d8d5cc] mt-6">
                <dl className="grid grid-cols-2 gap-y-4 text-[13px]">
                  <dt className="text-[#6b6b64] uppercase tracking-[0.14em] text-[11px]">Based</dt>
                  <dd className="text-[#0d0d0d]">{profile.location}</dd>
                  <dt className="text-[#6b6b64] uppercase tracking-[0.14em] text-[11px]">Status</dt>
                  <dd className="text-[#0d0d0d]">{profile.availability}</dd>
                  <dt className="text-[#6b6b64] uppercase tracking-[0.14em] text-[11px]">Experience</dt>
                  <dd className="text-[#0d0d0d]">10+ years</dd>
                </dl>
              </div>
            </div>

            <div>
              <p className="text-[11px] tracking-[0.18em] uppercase text-[#6b6b64] mb-4">
                Services
              </p>
              <ul className="border-t border-[#d8d5cc]">
                {services.map((s) => (
                  <li
                    key={s}
                    className="flex items-center border-b border-[#d8d5cc] py-3 text-[#0d0d0d] text-[15px]"
                  >
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
